import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import ActionIcon from "../common/ActionIcon";
import { dispatchEvent } from "../../utils/analytics";
var useStyles = createUseStyles(function (theme) { return ({
    root: {
        display: "block",
        position: "relative",
        alignContent: "center",
        maxWidth: 389,
        maxHeight: 267,
    },
    cover: {
        display: "flex",
        flexDirection: "row",
        minHeight: 267,
        "&:hover": {
            cursor: "pointer",
        },
    },
    cardBackground: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: function (props) {
            return "url(\"" + props.backgroundImage + "\") center/cover no-repeat " + props.backgroundColor;
        },
    },
    media: {
        display: "flex",
        position: "relative",
        flexDirection: "column",
        padding: "0 20px",
        minHeight: 267,
        textAlign: function (props) {
            return props.buttonPosition === "bottomRight" ? "right" : "left";
        },
        width: "100%",
    },
    text: {
        color: function (props) { return props.textColor; },
        fontSize: 24,
        fontWeight: "normal",
        lineHeight: "135%",
        width: "60%",
        alignSelf: function (props) {
            return props.buttonPosition === "bottomRight" ? "flex-end" : "flex-start";
        },
        marginBottom: "auto",
        "& p": {
            margin: "1em 0",
        },
    },
    cta: {
        marginBottom: 20,
        alignSelf: function (props) {
            return props.buttonPosition === "bottomRight" ? "flex-end" : "flex-start";
        },
    },
    button: {
        display: "flex",
        flexDirection: "row",
        backgroundColor: theme.colors.white,
        color: theme.colors.asurion.purple,
        borderRadius: 999,
        fontSize: 16,
        padding: "12px 16px",
        height: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        appearance: "none",
        "-wekbit-appearance": "none",
        border: "none",
        fontFamily: "inherit",
        cursor: "pointer",
    },
}); });
var ContentCardLoader = function (_a) {
    var buttonPosition = _a.buttonPosition, buttonText = _a.buttonText, onClick = _a.onClick, headline = _a.headline, backgroundColor = _a.backgroundColor, textColor = _a.textColor, backgroundImage = _a.backgroundImage;
    var classes = useStyles({
        backgroundColor: backgroundColor,
        backgroundImage: backgroundImage,
        textColor: textColor,
        buttonPosition: buttonPosition,
    });
    return (React.createElement("div", { className: classes.root },
        React.createElement("div", { className: classes.cover, "data-testid": "card-click", onClick: function () {
                dispatchEvent("ContentCard_Clicked", { headline: headline });
                if (onClick)
                    onClick();
            } },
            React.createElement("div", { className: classes.cardBackground }),
            React.createElement("div", { className: classes.media },
                React.createElement("div", { className: classes.text },
                    React.createElement("p", null, headline)),
                React.createElement("div", { className: classes.cta },
                    React.createElement("button", { className: classes.button },
                        buttonText,
                        "\u00A0",
                        React.createElement(ActionIcon, null)))))));
};
ContentCardLoader.defaultProps = {
    textColor: "#000000",
    backgroundColor: "#FFFFFF",
};
ContentCardLoader.propTypes = {
    buttonPosition: PropTypes.oneOf(["bottomLeft", "bottomRight"])
        .isRequired,
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    headline: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    textColor: PropTypes.string.isRequired,
    backgroundImage: PropTypes.any,
};
export default ContentCardLoader;
